import { Component, Input, OnInit } from '@angular/core';
import { RowBlockSimple, RowSimple } from 'src/app/shared/models/node';

@Component({
  selector: 'app-highlighted-paragraph',
  templateUrl: './highlighted-paragraph.component.html',
  styleUrls: ['./highlighted-paragraph.component.scss']
})
export class HighlightedParagraphComponent implements OnInit {

  @Input() block: RowBlockSimple = {} as RowBlockSimple;
  public classColumn: string = '';

  constructor() { }

  ngOnInit(): void {
    this.setColumnItem();
  }

  private setColumnItem() {
    if (this.block.colonne_occupate === '4') {
      this.classColumn = 'col-12 col-md-9 m-auto'
    } else {
      this.classColumn = 'col-12'
    }
  }

}
